import { useEffect } from 'react';
import { toast } from 'sonner';
import { useChannelQuotas } from '@/features/channel-quota/model/use-channel-quotas';
import { clearChannelNotices, syncChannelQuotaNotice } from '../model/inbox';
import type { Passbook } from '@/shared/types';

/** Dispara avisos de 80% e de cota esgotada a partir da cota já carregada. */
export function QuotaNoticeSync({ passbook, passbookId }: { passbook?: Passbook | null; passbookId?: string }) {
  const loaded = Boolean(passbook);
  const emailOn = passbook?.hasEmailMarketing === true;
  const smsOn = passbook?.hasSmsMarketing === true;
  const { quotas, live } = useChannelQuotas(emailOn || smsOn ? passbookId : undefined);

  // Avisos ficam no localStorage: com o canal desligado, os antigos somem do sino.
  useEffect(() => {
    if (!passbookId || !loaded) return;
    if (!emailOn) clearChannelNotices(passbookId, 'email');
    if (!smsOn) clearChannelNotices(passbookId, 'sms');
  }, [emailOn, loaded, passbookId, smsOn]);

  useEffect(() => {
    if (!passbookId || !quotas || !live) return;
    const created = [
      ...(emailOn ? syncChannelQuotaNotice(passbookId, 'email', quotas.email) : []),
      ...(smsOn ? syncChannelQuotaNotice(passbookId, 'sms', quotas.sms) : []),
    ];
    for (const notice of created) {
      toast.warning(notice.title, { id: notice.id, description: notice.body });
    }
  }, [emailOn, live, passbookId, quotas, smsOn]);

  return null;
}
